import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=15bd85e0&scoped=true&lang=pug&"
import script from "./LoginFooter.vue?vue&type=script&lang=js&"
export * from "./LoginFooter.vue?vue&type=script&lang=js&"
import style0 from "./LoginFooter.vue?vue&type=style&index=0&id=15bd85e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bd85e0",
  null
  
)

export default component.exports